import 'react';
import classnames from 'classnames';
import * as formats from '@thisisbud/intl-formats';
import { jsx } from 'react/jsx-runtime';

const formattedDateClassName = 'bui-formatted-date';

// @ts-expect-error Add backwards compatibility with the previous version of the `@thisisbud/intl-formats` package
const dateFormats = typeof formats.dateTime !== 'undefined' ? formats.dateTime : formats.date;
const defaultFormatDate = new Intl.DateTimeFormat('en-GB', dateFormats.default);

/**
 * Renders a date in a localized format with an additional machine readable format.
 * By default the date is rendered with the default date format from `@thisisbud/intl-formats` and for the `en-GB` locale, but this can be modified by providing a custom date formatting function via the `formatDate` prop.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { FormattedDate } from '@thisisbud/bui-react-formatted-date'
 *
 * const today = new Date()
 *
 * function Example() {
 *   return <FormattedDate date={today}/>
 * }
 * ```
 */
function FormattedDate(props) {
  const {
    className,
    date,
    formatDate
  } = props;
  const formatDateFn = typeof formatDate === 'function' ? formatDate : defaultFormatDate.format;
  return /*#__PURE__*/jsx("time", {
    className: classnames(formattedDateClassName, className),
    dateTime: date.toISOString(),
    children: formatDateFn(date)
  });
}
FormattedDate.displayName = 'FormattedDate';

export { FormattedDate, formattedDateClassName };
